/**
 * 生成文字签名图（透明底 PNG），风格接近 e签宝「姓名签」
 */

const SIGN_STYLES = [
  {
    id: 'xingkai',
    label: '行楷',
    fontFamily: '"SignXingkai", "STXingkai", "华文行楷", "KaiTi", "楷体", serif',
    fontWeight: '400',
    italic: true,
    color: '#1a1a1a',
  },
  {
    id: 'kaiti',
    label: '楷体',
    fontFamily: '"KaiTi", "楷体", "STKaiti", "Songti SC", serif',
    fontWeight: '500',
    italic: false,
    color: '#111111',
  },
  {
    id: 'brush',
    label: '手写',
    fontFamily: '"SignBrush", "Zhi Mang Xing", "Ma Shan Zheng", "STXingkai", cursive',
    fontWeight: '400',
    italic: false,
    color: '#0d0d0d',
  },
]

let fontReadyPromise = null

/** 预加载网络手写字体（失败则回落系统字体） */
export function ensureSignFonts() {
  if (fontReadyPromise) return fontReadyPromise
  fontReadyPromise = (async () => {
    if (typeof FontFace === 'undefined' || !document.fonts) return false
    const faces = [
      {
        family: 'SignXingkai',
        url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/mashanzheng/MaShanZheng-Regular.ttf',
      },
      {
        family: 'SignBrush',
        url: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/zhimangxing/ZhiMangXing-Regular.ttf',
      },
    ]
    await Promise.all(
      faces.map(async (item) => {
        try {
          const face = new FontFace(item.family, `url(${item.url})`, {
            display: 'swap',
          })
          const loaded = await face.load()
          document.fonts.add(loaded)
        } catch (e) {
          console.warn('[textSign] font load fail', item.family, e)
        }
      }),
    )
    return true
  })()
  return fontReadyPromise
}

export function getSignStyles() {
  return SIGN_STYLES.map(({ id, label }) => ({ id, label }))
}

/**
 * @param {string} name
 * @param {string} styleId
 * @returns {string} dataURL png
 */
export function generateTextSignature(name, styleId = 'xingkai') {
  const text = String(name || '').trim()
  if (!text) {
    throw new Error('请填写签署人姓名')
  }

  const style = SIGN_STYLES.find((s) => s.id === styleId) || SIGN_STYLES[0]
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  if (!ctx) {
    throw new Error('当前环境不支持生成签名')
  }

  // 按字数适配字号，保证落签区清晰
  const charCount = text.length
  let fontSize = 96
  if (charCount >= 5) fontSize = 72
  if (charCount >= 8) fontSize = 56

  const fontCss = `${style.italic ? 'italic ' : ''}${style.fontWeight} ${fontSize}px ${style.fontFamily}`
  ctx.font = fontCss
  const metrics = ctx.measureText(text)
  const padX = Math.ceil(fontSize * 0.35)
  const padY = Math.ceil(fontSize * 0.4)
  const width = Math.max(Math.ceil(metrics.width) + padX * 2, fontSize * 2)
  const height = Math.ceil(fontSize * 1.55) + padY

  canvas.width = width
  canvas.height = height

  // 透明底
  ctx.clearRect(0, 0, width, height)
  ctx.font = fontCss
  ctx.fillStyle = style.color
  ctx.textBaseline = 'middle'
  ctx.textAlign = 'left'

  // 轻微描边，接近电子签打印观感
  ctx.lineWidth = Math.max(1, fontSize / 48)
  ctx.strokeStyle = 'rgba(0,0,0,0.08)'
  ctx.strokeText(text, padX, height / 2)
  ctx.fillText(text, padX, height / 2)

  return canvas.toDataURL('image/png')
}

/**
 * 预生成全部样式预览
 * @param {string} name
 * @returns {Array<{id:string,label:string,dataUrl:string}>}
 */
export function generateAllTextSignatures(name) {
  return SIGN_STYLES.map((s) => ({
    id: s.id,
    label: s.label,
    dataUrl: generateTextSignature(name, s.id),
  }))
}
